import { dimensions, zonesOrder } from '@/app/dashboard/data'
import { ActionPoint, ActionPointTopic, SurveyGroup } from '@/types'

export const actionPointIsCompletelyFilled = (actionPoint: ActionPoint): boolean => {
  if (!dimensions.includes(actionPoint.dimension)) {
    return false
  }

  if (!Object.values(SurveyGroup).includes(actionPoint.surveyGroupType)) {
    return false
  }

  if (Object.values(ActionPointTopic).includes(actionPoint.topic) === false) {
    return false
  }

  if (Object.values(zonesOrder).includes(actionPoint.zone) === false) {
    return false
  }

  if (!actionPointTextIsCompletelyFilled(actionPoint.texts.de)) {
    return false
  }

  if (!actionPointTextIsCompletelyFilled(actionPoint.texts.en, true)) {
    return false
  }

  return true
}

export const actionPointTextIsCompletelyFilled = (
  text: ActionPoint['texts']['de'] | ActionPoint['texts']['en'],
  isEn = false,
): boolean => {
  if (!text.text || text.text.trim().length === 0) {
    return false
  }

  if ((!text.problemIndicators || text.problemIndicators.length < 3) && !isEn) {
    return false
  }

  if ((!text.solutionIndicators || text.solutionIndicators.length < 3) && !isEn) {
    return false
  }

  if (!text.details || !text.details.description1 || text.details.description1.trim().length === 0) {
    return false
  }

  if (!text.details || !text.details.description2 || text.details.description2.trim().length === 0) {
    return false
  }

  if (!text.details || !text.details.points || text.details.points.length < 3) {
    return false
  }

  return true
}
